// API configuration for different environments
const getApiBaseUrl = () => {
  // In development, use the proxy or localhost
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8000';
  }
  
  // In production, use the same domain (Vercel handles routing)
  return '';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  REFRESH: '/api/auth/refresh',
  
  // Chat endpoints
  CHAT_QUERY: '/api/chat/query',
  
  // QuickBooks endpoints
  QB_STATUS: '/api/quickbooks/status',
  QB_CONNECT: '/api/quickbooks/connect',
  QB_DISCONNECT: '/api/quickbooks/disconnect',
  
  // Document endpoints
  UPLOAD_DOCUMENT: '/api/documents/upload',
  GET_DOCUMENTS: '/api/documents',
  
  // User endpoints
  GET_USER: '/api/users/me',
  UPDATE_USER: '/api/users/me',
};

export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
}; 